import { DEVICE_ID } from 'src/environments/runtime';

/**
 * Ensures a device id has the `device-` prefix expected by the Helmsdeep API.
 * Returns '' for null, undefined, empty, whitespace-only, or degenerate
 * `device-` (prefix with no suffix) inputs.
 */
export const ensureDevicePrefix = (id: string | null | undefined): string => {
  const trimmed = (id ?? '').trim();
  if (!trimmed) {
    return '';
  }
  if (trimmed.startsWith('device-')) {
    const suffix = trimmed.slice('device-'.length);
    return suffix ? trimmed : '';
  }
  return `device-${trimmed}`;
};

/**
 * Resolves the effective device id using precedence:
 *   1. caller-provided id (may be null/undefined)
 *   2. sessionStorage.getItem('deviceId') on the supplied window
 *   3. runtime DEVICE_ID constant
 * Each source passes through ensureDevicePrefix, so the returned value is
 * guaranteed to be either '' or begin with `device-`.
 */
export const resolveDeviceId = (window?: Window | null, callerId?: string | null): string => {
  const sessionId = window?.sessionStorage?.getItem('deviceId') ?? null;
  return (
    ensureDevicePrefix(callerId) || ensureDevicePrefix(sessionId) || ensureDevicePrefix(DEVICE_ID)
  );
};
